import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import theme from '../../theme/theme';
import { postFavourite } from '../../services/favourites/postFavourites';
import { deleteFavourite } from '../../services/favourites/deleteFavourites';
import { getFavouritesList } from '../../services/favourites/getFavourites';
import { FavoriteButtonProps } from './types';
import { IconButton } from '@mui/material';
import { Star } from '@mui/icons-material';

const FavoriteButton: React.FC<FavoriteButtonProps> = ({ resourceId, type = 'complete' }) => {
  // ------------------- JWT -------------------
  let jwt = localStorage.getItem('jwt');
  
  // ------------------- STATES -------------------
  const [isFav, setIsFav] = useState(false);
  const [favouritesList, setFavouritesList] = useState<any>([]); // Favourites list state
  const [serverResponse, setServerResponse] = useState(false); // Server response state
  const [isUpdating, setIsUpdating] = useState(false); // Estado para rastrear si se está actualizando

  // ------------------- GET RESOURCES FROM API -------------------

  const postFavouriteById = async (token: string, id: number) => {
    await postFavourite(token, id)
      .then((res) => {
        if (res && res.data) {
          if (res.status !== 200) {
            setServerResponse(false);
          } else {
            setServerResponse(true);
          }
        }
      })
      .catch((err) => {
        setServerResponse(true);
      });
  };

  const deleteFavouriteById = async (token: string, id: number) => {
    await deleteFavourite(token, id)
      .then((res) => {
        if (res && res.data) {
          if (res.status !== 200) {
            setServerResponse(false);
          } else {
            setServerResponse(true);
          }
        }
      })
      .catch((err) => {
        setServerResponse(true);
      });
  }

  const checkFavoriteStatus = async () => {
    await getFavouritesList(jwt!)
      .then((res) => {
        if (res && res.data) {
          setFavouritesList(res.data.favourites_list);
          const isResourceFavorite = res.data.favourites_list.some((fav: any) => fav.id === resourceId);
          setIsFav(isResourceFavorite);
        }
      })
      .catch((err) => {
        // Handle error if necessary
      });
  }

  const handleClick = async () => {
    if (isUpdating) {
      return; // Si ya se está actualizando, no hacer nada
    }

    setIsUpdating(true); // Indicar que se está actualizando

    try {
      if (!isFav) {
        await postFavouriteById(jwt!, resourceId!);
      } else {
        await deleteFavouriteById(jwt!, resourceId!);
      }

      setTimeout(() => {
        setIsUpdating(false); // Terminar la actualización visual
      }, 1000); // 1000 ms de tiempo de espera (ajusta según sea necesario)

      setIsFav(!isFav); // Actualizar el estado inmediatamente
    } catch (error) {
      setIsUpdating(false); // Manejar el error y terminar la actualización
    }
  };

  useEffect(() => {
    checkFavoriteStatus();
  }, [isFav]);

  return (
    type === 'complete' ? (
      <Button 
        startIcon={isFav ? <StarIcon sx={{color: theme.color.honey}}/> : <StarOutlineIcon />} 
        onClick={handleClick}
        variant="contained"
        sx={{
          width: "auto",
          borderRadius: "7px",
          fontSize: "16px",
          backgroundColor: isFav  ? theme.color.peach : theme.color.pale,
          color: theme.color.black,
          textTransform: "none",
          "&:hover": {
            backgroundColor: isFav  ? '#FAE9C3' : theme.color.silver,
          },
        }}
      >
        {isFav ? 'Eliminar Favorito' : 'Agregar a Favoritos'}
      </Button>
    ) : (
      <IconButton onClick={handleClick}>
        <Star
          sx={{
            color: isFav  ? theme.color.honey : theme.color.silver,
            fontSize: "40px",
            cursor: "pointer",
          }}
        />
      </IconButton>
    )
  );
};

export default FavoriteButton;
